import { render, staticRenderFns } from "./DIconPlus.vue?vue&type=template&id=58bdec3f&"
import script from "./DIconPlus.vue?vue&type=script&lang=js&"
export * from "./DIconPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports